import React, { useEffect } from 'react';
import { Button, TextField, FieldController } from '@keplerco/core';
import classNames from 'classnames';
import layoutStyles from '../../../../design/layout.module.css';
import { useForm } from 'react-hook-form';
import { useAppActions, useAppState } from '../../../../overmind';
import { PagePath } from '../../../../navigation/navigation.enums';
import { FetchType } from '../../../../enums';
import { EntitiesCardWidget } from '../../../../components/cards/entities-card.widget';

// Props for the company info page
interface YourInfoPageProps {
  onNext: () => void;
}

/**
 * Company Info onboarding step
 * Collects basic company information
 */

interface IFormValues {
  firstName: string;
  lastName: string;
  jobTitle: string;
}

export function YourInfoPage({ onNext }: YourInfoPageProps): JSX.Element {
  const actions = useAppActions();
  const { user } = useAppState();


  const { handleSubmit, control, reset } = useForm<any>({
    mode: 'onBlur'
  });

  useEffect(() => {
    reset({
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
      jobTitle: user?.jobTitle || '',
    });
    // Also update the websites array
  }, [user, reset]);

  // Form validation

  // Handle form submission
  const handleContinue = async (formValues: IFormValues) => {
    // Validate form
    const newErrors: { [key: string]: string } = {};
    if (!formValues.jobTitle) {
      newErrors.size = 'Job title is required';
    }
    // Save data to state
    actions.startLoader({ path: PagePath.onboarding, type: FetchType.Sending });
    await actions.updateYourInformation({
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      jobTitle: formValues.jobTitle,
    });
    await actions.getUser();
    actions.stopLoader(PagePath.onboarding);
    // Go to next step
    onNext();
  };

  return (
    <form style={{ display: 'flex', flexDirection: 'column', gap: 24, width: '100%' }} onSubmit={handleSubmit(handleContinue)}>
      <EntitiesCardWidget title="Your Information" description="This information helps us customize your skills and roles taxonomy to best fit your organization.">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <FieldController
              name="firstName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  placeholder=""
                  type="text"
                  label="First name"
                  responsive
                />
              )}
            />
          </div>
          <div>
            <FieldController
              name="lastName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  placeholder=""
                  type="text"
                  label="Last name"
                  responsive
                />
              )}
            />
          </div>
          <div>
            <FieldController
              name="jobTitle"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  placeholder=""
                  type="text"
                  label="Job title"
                  responsive
                />
              )}
            />
          </div>
        </div>
      </EntitiesCardWidget>

      <footer className={classNames('card', layoutStyles.wizardFooter)} style={{ justifyContent: 'flex-end' }}>
        <Button type="button" filled>
          Next
        </Button>
      </footer>
    </form>
  );
}
